export const PRODUCT_CATEGORIES = [
  { id: "all", label: "全部產品" },
  { id: "fresh", label: "鮮果" },
  { id: "frozen", label: "急凍產品" },
];

export function getCategoryLabel(categoryId) {
  return PRODUCT_CATEGORIES.find((c) => c.id === categoryId)?.label ?? "";
}
